import muistyled from "@emotion/styled";
import { Grid } from "@mui/material";
import BGImg2 from "../images/img2.jpg";
import { SwingIn } from "../../animations/animations";
import { TabList } from "@mui/lab";

export const AboutMeSectionContainer = muistyled(Grid, {
  name: "AboutMeSectionContainer",
})({
  height: "1000px",
  backgroundColor: "#191919",
  justifyContent: "center",
  alignItems: "center",
  "@media (max-width: 910px)": {
    height: "1200px",
  },
});

export const AboutMeTitleWrap = muistyled(Grid, {
  name: "AboutMeTitleWrap",
})({
  justifyContent: "center",
  alignItems: "center",
});

export const TabContentWrap = muistyled(Grid, {
  name: "AboutMeTitleWrap",
})({
  animation: `${SwingIn} 1s ease-in-out`,
  color: "#fff",
});

export const ImageWrap = muistyled(Grid, {
  name: "ImageWrap",
})({
  display: "flex",
});
export const ImgGrid = muistyled(Grid, {
  name: "ImgGrid",
})({
  height: "650px",
  width: "450px",
  boxShadow: "0px 0px 10px #000",
  backgroundImage: `url(${BGImg2})`,
  borderRadius: "20px",
  backgroundSize: "cover",
  "@media screen and (max-width: 910px)": {
    height: "400px",
    width: "400px",
  },
});

export const AboutMeTextWrap = muistyled(Grid, {
  name: "AboutMeTextWrap",
})({
  animation: `${SwingIn} 1s both `,
  justifyContent: "center",
  alignItems: "center",
});

export const TabsWrap = muistyled(Grid, {
  name: "TabsWrap",
})({
  height: "330px",
});

export const StyledTabList = muistyled(TabList, {
  name: "StyledTabList",
})({
  "& .MuiTabs-indicator": {
    backgroundColor: "#FFF",
  },
  "& 	.MuiTab-textColorInherit": {
    color: "#7C9473",
  },
});

export const aboutStylesText = {
  color: "#fff",
  textAlign: "flex-start",
  fontSize: "1.8rem",
  fontFamily: "Oswald",
  "@media screen and (max-width: 910px)": {
    fontSize: "1.5rem",
    padding: "20px",
  },
};
export const aboutTitleTypo = {
  color: "#fff",
  fontSize: "2.5rem",
  fontWeight: "bold",
  fontFamily: "Oswald",
  paddingTop: "100px",
  "@media screen and (max-width: 910px)": {
    fontSize: "2rem",
    padding: "20px",
  },
};
